// console.log(process.env.NODE_ENV);
// console.log(process.env.API_URL);

// console.log("We also like to peek at the console 😁");
import { Init } from "./init";
// import { SwupTransition } from "./swup";

document.addEventListener("DOMContentLoaded", () => {
	Init();
	// SwupTransition();
});

